<div *ngIf="isLoading" class="loading-overlay">
  <div class="loader-section">
      <div class="preview-box">
        <div class="dots">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
</div>
